/* eslint-disable */
import wrapper from 'wrapper';
// polyfills
Number.isNaN = Number.isNaN || function (value) {
  return value !== value;
}
import 'core-js/es6/array';
import 'intersection-observer';
import 'classlist-polyfill';
// other bits we need
import * as bug from './debug';
import * as fallback from './ie-fallback';
import events from './events-emitter';

/* eslint-enable */

// adapted from https://github.com/russellgoldenberg/scrollama

class Scrolly {
    constructor(setup) {
        this.OBSERVER_NAMES = [
            'stepAbove',
            'stepBelow',
            'viewportAbove',
            'viewportBelow',
        ];

        this.step = setup.step;
        this.graphic = setup.graphic;
        this.container = setup.container;
        this.textContainer = setup.textContainer;
        this.offset = setup.offset || 0.5;
        this.isDebug = setup.debug || false;
        this.supportNoSticky = setup.supportIE || true;

        this.stepClass = this.step;
        this.id = `bbc-vj-scrolly-${Date.now()}`;

        this.io = {};
        this.stepEl = wrapper.selectAll(this.step) || [];
        this.stepOffsetHeight = [];
        this.stepOffsetTop = [];
        this.stepStates = [];

        this.offsetVal = 0;
        this.offsetMargin = 0;
        this.viewH = 0;
        this.pageH = 0;
        this.previousYOffset = 0;
        this.browserSupportsSticky = fallback.supportsStickyCheck();

        // if the scrolly is in an iframe, it will not instantiate the scroller
        // but shadow dom in an embed page will work
        this.iframe = (wrapper.meta().wrapper === 'embed');
        this.iframe ? wrapper.select(this.container).classList.add('fallback') : this.init(); // eslint-disable-line no-unused-expressions
    }

    init() {
        this.isReady = true;
        this.isEnabled = false;
        this.direction = 'down';
        this.offsetTrigger = this.setOffsetTrigger();

        this.checkStepEls();
        this.addDebug();
        this.indexSteps();
        this.setupStates();
        this.addAttributesForStyling();
        this.handleResize();
        this.handleEnable(true);
        this.addNoStickySupport();
    }

    checkStepEls() {
        if (!this.stepEl.length) {
            console.error('scrolly error: no step elements, please pass a valid class name to the constructor');
        }
    }

    addDebug() {
        if (this.isDebug) {
            wrapper.select(this.container).classList.add('debug');
            bug.setupOffset({
                stepClass: this.stepClass,
                id: this.id,
                stepEl: this.stepEl,
                offsetVal: this.offsetVal,
            });
        }
    }

    indexSteps() {
        this.stepEl.forEach((el, i) => el.setAttribute('data-bbc-scrolly-index', i));
    }

    setupStates() {
        this.stepStates = this.stepEl.map(() => ({
            direction: null,
            state: null,
        }));
    }

    addAttributesForStyling() {
        wrapper.select(this.container).setAttribute('data-scrolly', 'container');
        wrapper.select(this.graphic).setAttribute('data-scrolly', 'graphic');
        wrapper.select(this.textContainer).setAttribute('data-scrolly', 'text-container');
        wrapper.selectAll(this.step).forEach((step) => step.setAttribute('data-scrolly', 'step'));
    }

    addNoStickySupport() {
        if (this.supportNoSticky && !this.browserSupportsSticky) {
            fallback.addScrollListener(this.graphic, this.container);
        }
    }

    setOffsetTrigger() {
        if (this.offset && !Number.isNaN(this.offset)) {
            this.offsetVal = Math.min(Math.max(0, this.offset), 1);
        }
        return this.offsetVal;
    }

    getOffsetTop(el) {
        // Set our distance placeholder
        let distance = 0;
        // Loop up the DOM
        if (el.offsetParent) {
            do {
                distance += el.offsetTop;
                el = el.offsetParent; // eslint-disable-line no-param-reassign
            } while (el);
        }
        // Return our distance
        return distance < 0 ? 0 : distance;
    }

    getPageHeight() {
        const body = wrapper.select('.bbc-news-vj-wrapper');
        return Math.max(body.scrollHeight, body.offsetHeight);
    }

    getIndex(element) {
        return +element.getAttribute('data-bbc-scrolly-index');
    }

    updateDirection() {
        if (window.pageYOffset > this.previousYOffset) this.direction = 'down';
        else if (window.pageYOffset < this.previousYOffset) this.direction = 'up';
        this.previousYOffset = window.pageYOffset;
    }

    disconnectObserver(name) {
        if (this.io[name]) this.io[name].forEach(d => d.disconnect());
    }

    handleResize() {
        this.viewH = window.innerHeight || document.documentElement.clientHeight;
        this.pageH = this.getPageHeight();
        this.offsetMargin = this.offsetVal * this.viewH;

        if (this.isReady) {
            this.stepOffsetHeight = this.stepEl.map(el => el.offsetHeight);
            this.stepOffsetTop = this.stepEl.map(this.getOffsetTop);
            if (this.isEnabled) this.updateIO();
        }

        if (this.isDebug) bug.updateOffset({ id: this.id, offsetMargin: this.offsetMargin });
    }

    handleEnable(enable) {
        if (enable && !this.isEnabled) {
            if (this.isReady) this.updateIO();
            this.isEnabled = true;
            return true;
        }
        this.OBSERVER_NAMES.forEach((name) => {
            this.disconnectObserver(name).bind(Scrolly);
        });
        this.isEnabled = false;
        return this.isEnabled;
    }

    notifyOthers(index, location) {
        if (location === 'above') {
        // check if steps above/below were skipped and should be notified first
            for (let i = 0; i < index; i++) {
                const ss = this.stepStates[i];
                if (ss.state !== 'enter' && ss.direction !== 'down') {
                    this.notifyStepEnter(this.stepEl[i], 'down', false);
                    this.notifyStepExit(this.stepEl[i], 'down');
                }
                else if (ss.state === 'enter') this.notifyStepExit(this.stepEl[i], 'down');
            }
        }
        else if (location === 'below') {
            for (let i = this.stepStates.length - 1; i > index; i--) {
                const ss = this.stepStates[i];
                if (ss.state === 'enter') {
                    this.notifyStepExit(this.stepEl[i], 'up');
                }
                if (ss.direction === 'down') {
                    this.notifyStepEnter(this.stepEl[i], 'up', false);
                    this.notifyStepExit(this.stepEl[i], 'up');
                }
            }
        }
    }

    notifyStepEnter(element, currentDirection, check = true) {
        const index = this.getIndex(element);
        const resp = { element, index, currentDirection };
        this.stepStates[index].direction = currentDirection;
        this.stepStates[index].state = 'enter';
        if (check) {
            this.notifyOthers(index, (currentDirection === 'down' ? 'above' : 'below'));
        }
        events.emit('step-enter', resp);
        if (!this.browserSupportsSticky && index === this.stepEl.length - 1) fallback.stick(this.graphic);
    }

    notifyStepExit(element, currentDirection) {
        const index = this.getIndex(element);
        const resp = { element, index, currentDirection };
        this.stepStates[index].direction = currentDirection;
        this.stepStates[index].state = 'exit';
        if (index !== this.stepEl.length - 1) events.emit('step-exit', resp);
        if (!this.browserSupportsSticky && index === this.stepEl.length - 1 && currentDirection === 'down') fallback.unstick(this.graphic);
    }

    intersectViewport([entry]) {
        this.updateDirection();
        const { isIntersecting, target, direction } = entry;
        const index = this.getIndex(target);
        const ss = this.stepStates[index];
        if (isIntersecting && this.direction === direction &&
        ss.direction === 'down' && ss.state !== 'enter'
        ) {
            this.notifyStepEnter(target, direction);
            this.notifyStepExit(target, direction);
        }
    }

    updateViewportAboveIO() {
        this.io.viewportAbove = this.stepEl.map((el, i) => {
            const marginTop = this.pageH - this.stepOffsetTop[i];
            const marginBottom = this.offsetMargin - this.viewH - this.stepOffsetHeight[i];
            const rootMargin = `${marginTop}px 0px ${marginBottom}px 0px`;
            const options = { rootMargin };
            el.direction = 'down'; // eslint-disable-line no-param-reassign
            const obs = new IntersectionObserver(this.intersectViewport.bind(this), options);
            obs.observe(el);
            return obs;
        });
    }

    updateViewportBelowIO() {
        this.io.viewportBelow = this.stepEl.map((el, i) => {
            const marginTop = -this.offsetMargin - this.stepOffsetHeight[i];
            const marginBottom = this.offsetMargin - this.viewH + this.stepOffsetHeight[i] + this.pageH;
            const rootMargin = `${marginTop}px 0px ${marginBottom}px 0px`;
            const options = { rootMargin };
            el.direction = 'up'; // eslint-disable-line no-param-reassign
            const obs = new IntersectionObserver(this.intersectViewport.bind(this), options);
            obs.observe(el);
            return obs;
        });
    }

    // scrollama (start)
    updateStepAboveIO() {
        if (this.io.stepAbove) this.io.stepAbove.forEach(d => d.disconnect());

        this.io.stepAbove = this.stepEl.map((el, i) => {
            const marginTop = this.stepOffsetHeight[i];
            const marginBottom = -this.viewH + this.offsetMargin;
            const rootMargin = `${marginTop}px 0px ${marginBottom}px 0px`;
            const options = { root: null, rootMargin, threshold: 0 };
            const obs = new IntersectionObserver(this.intersectStepAbove.bind(this), options);
            obs.observe(el);
            return obs;
        });
    }

    updateStepBelowIO() {
        if (this.io.stepBelow) this.io.stepBelow.forEach(d => d.disconnect());

        this.io.stepBelow = this.stepEl.map((el, i) => {
            const marginTop = -this.offsetMargin;
            const marginBottom = this.pageH - this.viewH + this.stepOffsetHeight[i] + this.offsetMargin;
            const rootMargin = `${marginTop}px 0px ${marginBottom}px 0px`;
            const options = { root: null, rootMargin, threshold: 0 };
            const obs = new IntersectionObserver(this.intersectStepBelow.bind(this), options);
            obs.observe(el);
            return obs;
        });
    }

    intersectStepAbove(entries) {
        this.updateDirection();
        entries.forEach(entry => {
            const { isIntersecting, boundingClientRect, target } = entry;

            // bottom is how far bottom edge of el is from top of viewport
            const { bottom, height } = boundingClientRect;
            const bottomAdjusted = bottom - this.offsetMargin;
            const index = this.getIndex(target);
            const ss = this.stepStates[index];

            if (bottomAdjusted >= -1) {
                if (isIntersecting && this.direction === 'down' && ss.state !== 'enter') {
                    this.notifyStepEnter(target, this.direction);
                }
                else if (!isIntersecting && this.direction === 'up' && ss.state === 'enter') {
                    this.notifyStepExit(target, this.direction);
                }
                else if (
                    !isIntersecting &&
                    bottomAdjusted >= height &&
                    this.direction === 'down' &&
                    ss.state === 'enter'
                ) {
                    this.notifyStepExit(target, this.direction);
                }
            }
        });
    }

    intersectStepBelow(entries) {
        this.updateDirection();
        entries.forEach(entry => {
            const { isIntersecting, boundingClientRect, target } = entry;

            const { bottom, height } = boundingClientRect;
            const bottomAdjusted = bottom - this.offsetMargin;
            const index = this.getIndex(target);
            const ss = this.stepStates[index];

            if (
                bottomAdjusted >= -1 &&
                bottomAdjusted < height &&
                isIntersecting &&
                this.direction === 'up' &&
                ss.state !== 'enter'
            ) {
                this.notifyStepEnter(target, this.direction);
            }
            else if (
                bottomAdjusted <= 1 &&
                !isIntersecting &&
                this.direction === 'down' &&
                ss.state === 'enter'
            ) {
                this.notifyStepExit(target, this.direction);
            }
        });
    }
    // scrollama (end)

    updateIO() {
        this.OBSERVER_NAMES.forEach((name) => {
            this.disconnectObserver(name);
        });
        this.updateViewportAboveIO();
        this.updateViewportBelowIO();
        this.updateStepAboveIO();
        this.updateStepBelowIO();
    }
}

export default Scrolly;
